export const getProductById = (id, productsOptions) =>
	productsOptions?.find((product) => product.value === id);
